import React from "react";
import { Brain, Wallet, Zap } from "lucide-react";
import Reveal from "./Reveal";

const ROWS = [
    {
        icon: Brain,
        title: "Більше не думаєте про рекламу",
        desc: "AI слідкує за кампанією замість вас. Ви займаєтесь бізнесом.",
        color: "#6D5EF8",
    },
    {
        icon: Wallet,
        title: "Знаєте куди йдуть кожні $10",
        desc: "Щотижневий звіт показує точно що спрацювало і що ні.",
        color: "#2DD4BF",
    },
    {
        icon: Zap,
        title: "Конкуренти платять агентству $400 — ви платите $20",
        desc: "Різниця $380 на місяць залишається у вас.",
        color: "#FBBF24",
    },
];

export const PersonalBenefit = () => {
    return (
        <section className="section bg-surface/30 border-y border-border" data-testid="personal-benefit">
            <div className="container-mx">
                <Reveal>
                    <h2 className="font-display font-extrabold text-text-primary max-w-[760px]" style={{ fontSize: "clamp(32px, 5vw, 52px)", letterSpacing: "-0.025em" }}>
                        Ви купуєте не рекламу. <br className="hidden md:block" />
                        <span className="text-primary-c">Ви купуєте спокій.</span>
                    </h2>
                </Reveal>

                <div className="mt-12 space-y-4">
                    {ROWS.map((r, i) => {
                        const Icon = r.icon;
                        return (
                            <Reveal key={i} delay={i * 0.12}>
                                <div
                                    data-testid={`benefit-${i}`}
                                    className="glass glass-hover rounded-2xl p-6 md:p-7 flex items-start md:items-center gap-5 md:gap-7"
                                >
                                    <div
                                        className="w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center shrink-0"
                                        style={{ background: `${r.color}15` }}
                                    >
                                        <Icon size={22} style={{ color: r.color }} />
                                    </div>
                                    <div className="flex-1">
                                        <h3 className="font-display font-bold text-lg md:text-xl text-text-primary">{r.title}</h3>
                                        <p className="mt-2 text-sm text-secondary-c leading-relaxed">{r.desc}</p>
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default PersonalBenefit;
